import script from "./GestaoAcessos.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoAcessos.vue?vue&type=script&setup=true&lang=js"

import "./GestaoAcessos.vue?vue&type=style&index=0&id=a4a1c832&lang=css"

const __exports__ = script;

export default __exports__